<template>
  <v-tabs
    v-if="show"
    show-arrows
    :icons-and-text="iconsAndText"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-tab v-for="_tab in tabs" :key="_tab.value" :href="`#${_tab.value}`">
      <!-- mobile -->
      <template v-if="$vuetify.breakpoint.mobile">
        {{ _tab.shortText ?? _tab.text }}
        <v-icon v-if="_tab.icon">{{ _tab.icon }}</v-icon>
      </template>
      <!-- desktop -->
      <template v-else>
        <v-icon v-if="_tab.icon" small left>{{ _tab.icon }}</v-icon>
        {{ _tab.text }}
      </template>
    </v-tab>
  </v-tabs>
</template>

<script>
import { VTabs, VTab, VIcon } from 'vuetify/lib'

export default {
  name: 'TabsBase',

  components: {
    VTabs,
    VTab,
    VIcon
  },

  model: {
    event: 'change'
  },

  props: {
    /**
     * Array of tabs:
     * [
     *  {
     *    text: 'Tab 1',
     *    shortText: 'T1', (optional)
     *    icon: '$icon',
     *    value: 'TAB_1'
     *  },
     *  {
     *    text: 'Tab 2',
     *    shortText: 'T2', (optional)
     *    icon: '$icon',
     *    value: 'TAB_2'
     *  }
     * ]
     */
    tabs: {
      type: Array,
      required: false,
      default: null
    }
  },

  computed: {
    show() {
      return Array.isArray(this.tabs) && this.tabs.length > 0
    },

    hasIcons() {
      return Array.isArray(this.tabs) && this.tabs.some((item) => !!item.icon)
    },

    iconsAndText() {
      return this.hasIcons && this.$vuetify.breakpoint.mobile
    }
  }
}
</script>
